import { useQuery } from "@tanstack/react-query"

import type { QueryFunctionContext } from "@tanstack/react-query"

import type { Response } from "@/services/types/priority"

type EntityId = string
const priorityKeys = {
    all: [{ _model: "legislative_priority" }] as const,
    detail: (filter: { [qdtRelatedField: string]: EntityId }) => [{ ...priorityKeys.all[0], filter }] as const,
}

const fetchPriority = async ({
    queryKey,
}: QueryFunctionContext<ReturnType<(typeof priorityKeys)["detail"]>>): Promise<Response> => {
    const [{ filter }] = queryKey

    return DjangIO.app.userdata.models.LegislativePriority.objects
        .filter({
            ...filter,
            estimated_count: true,
        })
        .GET()
}

export const usePriority = <TPriority>(
    entityId: string,
    qdtRelatedField: string,
    select?: (response: Response) => TPriority
) =>
    useQuery({
        queryKey: priorityKeys.detail({ [qdtRelatedField]: entityId }),
        queryFn: fetchPriority,
        enabled: Boolean(entityId),
        select,
    })
